import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useActivityStore } from "@/stores/activityStore";
import { useUserStore } from "@/stores/userStore";
import InvocationScrollList from "../Workflow/Invocation/InvocationScrollList.vue";
import ActivityPanel from "./ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InvocationsPanel',
    props: {
        activityBarId: null
    },
    setup(__props) {
        const props = __props;
        const { currentUser } = storeToRefs(useUserStore());
        const { toggledSideBar } = storeToRefs(useActivityStore(props.activityBarId));
        const shouldCollapse = ref(false);
        function collapseOnLeave() {
            if (shouldCollapse.value) {
                toggledSideBar.value = "";
            }
        }
        return { __sfc: true, props, currentUser, toggledSideBar, shouldCollapse, collapseOnLeave, BAlert, InvocationScrollList, ActivityPanel };
    }
});
